import type { TableEntry } from '@app/types'

import { createApp } from '@app/adapters/create-app'
import EntriesTable from '../components/entries-table.vue'
import EntriesTableUpdatable from '../components/entries-table-data-provider.vue'

export class SfEntriesMounter {
  constructor(
    element: HTMLElement,
    entries: {
      attributes: string[]
      headers: string[]
      entries: TableEntry[]
      translated_headers: string[]
      truncated: string
    },
    options: {
      updateEvent?: string
      hasMinWidth?: boolean
      hover?: boolean
      sidebarPreview?: boolean
    }
  ) {
    createApp(options.updateEvent ? EntriesTableUpdatable : EntriesTable, {
      attributes: entries.attributes,
      hasMinWidth: options.hasMinWidth,
      headers: entries.headers,
      isHoverable: options.hover,
      list: entries.entries,
      translatedHeaders: entries.translated_headers,
      truncated: entries.truncated,
      updateEvent: options.updateEvent,
      sidebarPreview:
        options.sidebarPreview || element.dataset.sidebarPreview === 'true',
    }).mount(element)
  }
}

// TODO: Stop exposing globally when Sprockets files are migrated to Webpack
export const exposeGlobally = (): void => {
  window.Silverfin.EntriesTables = {
    ...(window.Silverfin.EntriesTables || {}),
    EntriesTable: SfEntriesMounter,
  }
}
